/* @flow */

import clsx from 'clsx';
import * as React from 'react';
import { useCallback, useMemo } from 'react';

import './GameSlideshowNavigator.css';
import Localizer from '../../../helpers/localization';

type GameSlideshowNavigatorPropType = {
  +count: number,
  +currentIndex: number,
  +indexSelected: (index: number) => void,
};

const GameSlideshowNavigator = ({ count, currentIndex, indexSelected }: GameSlideshowNavigatorPropType): React.Node => {
  const indices = useMemo(() => {
    const arr = [];
    for (let i = 0; i < count; i++) {
      arr.push(i);
    }
    return arr;
  }, [count]);

  const handleOnClick = useCallback((event: SyntheticMouseEvent<HTMLElement>) => {
    const {
      currentTarget: { id },
    } = event;

    indexSelected(Number(id));
  }, []);

  return (
    <div className='gameSlideshowNavigator'>
      <div className='container'>
        {indices.map((i) => (
          <button
            aria-label={Localizer.localize('accessibility.gaming.show_image_by_index', { index: i + 1 })}
            className={clsx(i === currentIndex && 'selected')}
            id={i}
            key={i}
            onClick={handleOnClick}
            type='button'
          />
        ))}
      </div>
    </div>
  );
};

export default GameSlideshowNavigator;
